var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "short-right-arrow",
  "use": "short-right-arrow-usage",
  "viewBox": "0 0 167.626 135.243",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 167.626 135.243\" id=\"short-right-arrow\">\r\n<g id=\"short-right-arrow__x31__left\">\r\n</g>\r\n<g id=\"short-right-arrow__x31__right\">\r\n\t<path d=\"M0,58.243h141.442L92.376,9.728l9.891-9.484L168,65.853l-63.569,69.423l-10.326-9.673l48.369-53.359H0V58.243z\" />\r\n</g>\r\n<g id=\"short-right-arrow__x33_\">\r\n</g>\r\n<g id=\"short-right-arrow__x34_\">\r\n</g>\r\n<g id=\"short-right-arrow__x32_\">\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/short-right-arrow.icon
// module id = 131
// module chunks = 168707334958949